import Api from "./api";

export default {
  async getRegistrations(config, urlParams) {
    const response = await Api(config).get(`${config.api.registrationBase}?${urlParams.toString()}`);
    return response.data;
  },
  async getRegistration(config, registrationId) {
    const response = await Api(config).get(`${config.api.registrationBase}${registrationId}/`);
    return response.data;
  },
  async cancelRegistration(config, registrationId) {
    const response = await Api(config).delete(`${config.api.registrationBase}${registrationId}/cancel/`);
    return response.data;
  },
  async saveSurvey(config, registrationId, survey) {
    const response = await Api(config).patch(`${config.api.registrationBase}${registrationId}/save_survey/`, survey);
    return response.data;
  },
  async saveQuestions(config, registrationId, questions) {
    const response = await Api(config).post(
      `${config.api.registrationBase}${registrationId}/save_questions/`,
      questions
    );
    return response.data;
  },
  async getBundleData(config, registrationId) {
    const response = await Api(config).get(`${config.api.registrationBase}${registrationId}/bundle_data/`);
    return response.data;
  },
};
